import React from 'react';
import classNames from 'classnames';

export interface FooterNavProps {
  children?: React.ReactNode;
  className?: string;
  heading?: string;
  id?: string;
  size: 'slim' | 'medium' | 'big';
}

const FooterAddress = ({ children, className, heading, id, size }: FooterNavProps): JSX.Element => {
  const footerAddressClasses = classNames(className, 'usa-footer__address');

  return (
    <>
      {heading ? <h3 className="usa-footer__contact-heading">{heading}</h3> : null}
      {size === 'slim' ? (
        <div className="mobile-lg:grid-col-4">
          <address id={id} className={footerAddressClasses}>
            <div className="grid-row grid-gap">{children}</div>
          </address>
        </div>
      ) : null}
      {size === 'medium' ? (
        <address id={id} className={footerAddressClasses}>
          <div className="usa-footer__contact-info grid-row grid-gap">{children}</div>
        </address>
      ) : null}
    </>
  );
};

export default FooterAddress;
